import { useEffect, useState } from 'react';
import { Droppable } from '@hello-pangea/dnd';

/**
 * Droppable compatible con el StrictMode de React 18.
 *
 * En StrictMode los efectos se ejecutan dos veces en desarrollo y la librería
 * pierde el registro del contenedor, así que el drop deja de funcionar. Esperar
 * un frame antes de montarlo lo resuelve.
 *
 * Vive acá y no dentro de una página porque ya lo usan el tablero de Negocios
 * y el constructor de Cotizaciones.
 */
export default function StrictModeDroppable({ children, ...props }) {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        const id = requestAnimationFrame(() => setReady(true));
        return () => cancelAnimationFrame(id);
    }, []);

    if (!ready) return null;

    return <Droppable {...props}>{children}</Droppable>;
}
